import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PortraitIcon(props: IconProps) {
    return <Icon {...props} iconKey={"portrait"}/>
}
